// @ts-nocheck
import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaColorInput from './VaColorInput.vue'

export default withConfigTransport(VaColorInput)
